<script>
export default {
  components: {
    ProgressBar: () => import("../../../components/widgets/Graphs/ProgressBar.vue"),
    MainCard: () => import("../../../components/widgets/Cards/MainCard.vue"),
  },
  props: ["avgBusy", "msg"],
};
</script>

<template>
  <MainCard class="cardStatisticBusy">
    <template v-slot:wrapper>
      <div class="cardStatisticBusy__percentageHeader">
        <p class="cardStatisticBusy__title">{{ msg || "Porcentaje de ocupación" }}</p>
        <span class="cardStatisticBusy__percentageValue">{{ avgBusy + " %" }}</span>
      </div>
      <ProgressBar :widthBar="avgBusy" />
    </template>
  </MainCard>
</template>

<style lang="scss">
.cardStatisticBusy {
  &__percentageHeader {
    @include Flex(row, space-between);
    width: 100%;
    font-size: 24px;
    font-family: $sec_font;
  }
  &__percentageValue {
    color: $primary_color;
  }
}
</style>
